import {
  StyledInputWrapper,
  StyledInputLabel,
  StyledDropdownField,
  StyledTag,
  StyledFormItemField,
  StyledTagCloseButton,
} from "./style";
import type { TagsDropdownFieldProps } from "./interfaces";
import { SelectProps } from "antd";
import { useTranslation } from "react-i18next";

type antDTagRender = SelectProps["tagRender"];

export const TagRender: antDTagRender = (props) => {
  const { label, value, closable, onClose } = props;

  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <StyledTag
      color={value}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      closeIcon={closable ? <StyledTagCloseButton /> : undefined}
    >
      {label}
    </StyledTag>
  );
};

export const TagsDropdownField = (props: TagsDropdownFieldProps) => {
  const { t } = useTranslation();

  return (
    <StyledInputWrapper>
      <StyledInputWrapper>
        {props.label && <StyledInputLabel>{props.label}</StyledInputLabel>}
        <StyledFormItemField name={props.name} rules={props.rules}>
          <StyledDropdownField
            allowClear
            mode={props.mode}
            suffixIcon={props.isEditable ? undefined : null}
            isEditable={props.isEditable}
            tagRender={(tagProps) =>
              TagRender({ ...tagProps, closable: !!props.isEditable })
            }
            style={{ width: "100%" }}
            options={props.options}
            placeholder={
              props.isEditable ? props.placeholder || t("Select") : t("Empty")
            }
            filterOption={(input, option) =>
              (option?.label as string).includes(input)
            }
            variant={props.isEditable ? "outlined" : "borderless"}
          />
        </StyledFormItemField>
      </StyledInputWrapper>
    </StyledInputWrapper>
  );
};
